import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './news.css';
import img1 from '../../../assets/images/news.png';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import logo1 from '../../../assets/images/facebook1.svg';
import logo2 from '../../../assets/images/twitter1.svg';
import logo3 from '../../../assets/images/linkedIn1.svg';
import useGetAboutData from '../../../Hooks/useGetAboutData';
import { useSelector } from 'react-redux';

const News = ({ source }) => {
  // useGetAboutData();
  const data = useSelector((store) => store.data.AboutData)
  const [News, setNews] = useState({})
  const [Title, setTitle] = useState("")
  useEffect(() => {
    if (data?.items) {
      data.items.forEach((ele) => {
        if (ele.Section === "MediaCoverage") {
          setNews(ele.Content);
          setTitle(ele.Title);
        }
      });
    }
  }, [data])
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://static.elfsight.com/platform/platform.js';
    script.async = true;
    script.onload = () => {
      // Elfsight will auto-initialize widgets
    };
    document.body.appendChild(script);
  }, []);
  const handleClick = (link) => {
    window.open(link, "_blank");
  }
  const [age, setAge] = React.useState('');

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const posts = new Array(5).fill({
    title: 'Easing Of Drone Regulations Has Made Business Viable: Skye Air',
    date: 'Mar 07, 2025',
    imageUrl: img1,
  });

  return (
    <div className="news-page-wrapper">

      {source !== "about" && (
        <div className="container">
          <div className="news-filter col-md-12">
            <h3 className="fw-bold">Media & Partner</h3>
            {/* <FormControl sx={{ m: 1, minWidth: 120 }}>
              <InputLabel id="demo-simple-select-helper-label">Newest</InputLabel>
              <Select
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                value={age}
                label="Newest to oldest"
                onChange={handleChange}
                sx={{
                  padding: '4px 3px',      
                  height: '36px',           
                  fontSize: '0.875rem',      
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      mt: 1,
                      padding: 0,
                    },
                  },
                }}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={10}>Ten</MenuItem>
                <MenuItem value={20}>Twenty</MenuItem>
                <MenuItem value={30}>Thirty</MenuItem>
              </Select>
            </FormControl> */}
          </div>
        </div>
      )}

      {source === "about" && (
        <motion.h4
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="heading1 capitalize-first-letter"
        >
          {Title}
        </motion.h4>
      )}
      <div className="cards-container1 row">
        {source !== "about" && (
          <div className="recent-news-container">
            {
              News?.Items?.length > 0 && (
                <div className="main-card">
                  <img
                    src={News?.Items[0]?.ImageUrl}
                    alt="Drone Delivery"
                    className="main-image"
                  />
                  <div className="main-content">
                    <h5 className=" news-title capitalize-letter">{News?.Items[0]?.Title}</h5>
                    <p className="date news-para">{News?.Items[0]?.Date}</p>
                    <button onClick={() => { handleClick(News?.Items[0]?.Link) }} className="mb-2 px-4 read-more-btn">Read More</button>
                  </div>
                </div>
              )
            }

            <div className="sidebar">
              <div className="social-icons">
                <span>Instagram</span>
                <div>
                  <a href="https://www.facebook.com/OfficialSkyeAirMobility/" target="_blank" >
                    <span className="icon"><img src={logo1} alt="Logo" className="footer-logo" height={25} /></span>
                  </a>
                  <a href="https://x.com/air_skye/" target="_blank" >
                    <span className="icon"><img src={logo2} alt="Logo" className="footer-logo" height={25} /></span>
                  </a>
                  <a href="https://in.linkedin.com/company/skyeairmobility" target="_blank" >
                    <span className="icon"><img src={logo3} alt="Logo" className="footer-logo" height={25} /></span>
                  </a>
                </div>
              </div>
              <div className="post-item">
              <div className="elfsight-app-d867bcb5-c9a2-4a42-8a61-1b0388f499f5" data-elfsight-app-lazy></div>
              <div class="hidden-bar"></div>
                </div>
            </div>
          </div>
        )}

        {(source === 'about' ? News?.Items?.slice(0, 2) : News?.Items?.slice(1))?.map((card, index) => (
          <motion.div
            key={index}
            className={`card ${source === 'about' ? 'col-md-4' : 'col-md-3'}`}
            initial={{ opacity: 0, y: 150 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.2 }}
          >
            <img src={card.ImageUrl} width={'100%'} alt="Not Found" style={{ height: '-webkit-fill-available' }} />
            <div className="news-heading">
              <h6 className="mt-1 news-title capitalize-letter">{card.Title}</h6>
              <p className="mt-1 news-para">{card.Date}</p>
              <button onClick={() => { handleClick(card.Link) }} className="mb-2 px-4 read-more-btn">Read More</button>
            </div>
          </motion.div>
        ))}
      </div>

    </div>
  );
};

export default News;
